import { FC, useEffect, useState, useMemo, useCallback } from 'react';
import { Dropdown, DropdownListItem, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { SaveUserLang } from 'shared/components/__ADDONS__/__LANG__/Utils/GetUserLang';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import useQueryState from 'shared/hooks/useQueryState';


export const getLang = (currentLang: string) =>  {
  if (currentLang.toString() === '[object Object]' || 
      currentLang === 'ru' ||
      currentLang === null ||
      currentLang === 'null') {
    return 'en'
  }
  return currentLang;
}


export const BLanguageSelectionComponentOnlines: FC<{ onLangSelect: (lang: string) => void, mobile?: boolean }> = ({ onLangSelect, mobile = false }) => {
  const { t, i18n } = useTranslation();
  const [{ lang }, setQueryParams] = useQueryState();

  const [currentLang, setCurrentLang] = useState(getLang(lang || localStorage.getItem('lang') || 'en'));
  const langs = useMemo(() => ([
    {
      iso: 'en',
      text: t('onlinesNav.langName.en'),
    },
    {
      iso: 'kz',
      text: t('onlinesNav.langName.kz'),
    }
    
  ]), [t])


  const updateLang = useCallback(() => {
    // @ts-ignores
    SaveUserLang(getLang(lang || localStorage.getItem('lang') || 'en'));
    setQueryParams({ lang: getLang(lang || localStorage.getItem('lang') || 'en')});
    i18n.changeLanguage(getLang(lang || localStorage.getItem('lang') || 'en'));
    setCurrentLang(getLang(lang || localStorage.getItem('lang') || 'en'));
  }, [ lang, i18n, setQueryParams ])

  useEffect(() => {
    if (currentLang !== i18n.language) {
      updateLang();
    }
  }, [currentLang, updateLang, lang, i18n ])


  return  (
    <FlexBox>
      <Dropdown 
        offsetX={-70} 
        hideArrow 
        target={<ArrowTopIconWithText 
          fill={'#909090'} 
          hideIcon 
          text={currentLang.toUpperCase()
          }/>
        }
      >
        {langs?.map((lang, idx) => (
          <DropdownListItem 
            isActive={lang.iso === currentLang} 
            key={idx} 
            onClick={() => onLangSelect?.(lang.iso)}
          >{lang.text}</DropdownListItem>
        ))}
      </Dropdown>
    </FlexBox>
  )
};
import { FC, useEffect, useState, useMemo, useCallback } from 'react';
import { Dropdown, DropdownListItem, FlexBox } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import { SaveUserLang } from 'shared/components/__ADDONS__/__LANG__/Utils/GetUserLang';
import ArrowTopIconWithText from 'shared/icons/ArrowTopIconWithText';
import useQueryState from 'shared/hooks/useQueryState';


export const getLang = (currentLang: string) =>  {
  if (currentLang.toString() === '[object Object]' || 
      currentLang === 'ru' ||
      currentLang === null ||
      currentLang === 'null') {
    return 'en'
  }
  return currentLang;
}


export const BLanguageSelectionComponentOnlines: FC<{ onLangSelect: (lang: string) => void, mobile?: boolean }> = ({ onLangSelect, mobile = false }) => {
  const { t, i18n } = useTranslation();
  const [{ lang }, setQueryParams] = useQueryState();

  const [currentLang, setCurrentLang] = useState(getLang(lang || localStorage.getItem('lang') || 'en'));
  const langs = useMemo(() => ([
    {
      iso: 'en',
      text: t('onlinesNav.langName.en'),
    },
    {
      iso: 'kz',
      text: t('onlinesNav.langName.kz'),
    }
    
  ]), [t])


  const updateLang = useCallback(() => {
    // @ts-ignores
    SaveUserLang(getLang(lang || localStorage.getItem('lang') || 'en'));
    setQueryParams({ lang: getLang(lang || localStorage.getItem('lang') || 'en')});
    i18n.changeLanguage(getLang(lang || localStorage.getItem('lang') || 'en'));
    setCurrentLang(getLang(lang || localStorage.getItem('lang') || 'en'));
  }, [ lang, i18n, setQueryParams ])

  useEffect(() => {
    if (currentLang !== i18n.language) {
      updateLang();
    }
  }, [currentLang, updateLang, lang, i18n ])


  return  (
    <FlexBox>
      <Dropdown 
        offsetX={-70} 
        hideArrow 
        target={<ArrowTopIconWithText 
          fill={'#909090'} 
          hideIcon 
          text={currentLang.toUpperCase()
          }/>
        }
      >
        {langs?.map((lang, idx) => (
          <DropdownListItem 
            isActive={lang.iso === currentLang} 
            key={idx} 
            onClick={() => onLangSelect?.(lang.iso)}
          >{lang.text}</DropdownListItem>
        ))}
      </Dropdown>
    </FlexBox>
  )
};
